import type { FC, ReactNode } from 'react'

import Link from 'next/link'
import { ArrowRightIcon } from '@/components/icons/icon-set'
import { Seo } from '@/components/generals/seo'
import { DocsLayout, DocsPageHeader } from '@/components/docs/docs-layout'
import { COMPONENT_NAV } from '@/constants/docs-nav'

/* Components index: every component with its Figma page, like shadcn's components list. */
const ComponentsIndex: FC = (): ReactNode => {
    return (
        <DocsLayout>
            <Seo title='Components' description='All 27 GoodUnited components, each with variants, sizes, states and guidance.' />
            <DocsPageHeader
                title='Components'
                description='Every GoodUnited component, built on shadcn naming and styled only with GoodUnited tokens. Open one to see its variants, sizes, states, guidance and options.'
                group='Components'
                figma='10 / Components and 11 / Components / Accordion'
            />
            <div className='grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3'>
                {COMPONENT_NAV.map(item => (
                    <Link
                        key={item.href}
                        href={item.href}
                        className='group flex flex-col gap-2 rounded-xl border border-border-subtle bg-surface-raised p-5 transition-colors outline-none hover:border-border-strong focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-focus'
                    >
                        <span className='flex items-center justify-between gap-2 font-heading text-lg font-semibold text-text-primary'>
                            {item.title}
                            <ArrowRightIcon className='size-4 text-icon-tertiary transition-transform group-hover:translate-x-0.5' aria-hidden='true' />
                        </span>
                        <span className='text-sm text-text-secondary'>
                            {item.description}
                        </span>
                    </Link>
                ))}
            </div>
        </DocsLayout>
    )
}

export default ComponentsIndex
